import React, {useEffect, useState} from "react";
import {HttpClient} from "../../../service/httpClient/HttpClient";
import "./InternalImageSelector.scss"
import Fancybox from "../../fancybox/Fancybox";
import FileManagerSelector from "../../../pages/fileManager2/selector/FileManagerSelector";
import {FileManagerTypes} from "../../../component/fileManager/FileManager";
import {changeContent, EditorItemType, prepareEditorItem} from "../RaikoCustomEditor2";
import thumbnail from "../image/Focus-cuate.svg"
import {DialogSize, RaikoDefaultDialogPage, RaikoSectionContainer} from "@moeindal/base-raiko-panel-components";

export default function InternalImageSelector(
    {
        value,
        setValue=()=>{},
        imageId,
        setImageId=()=>{},
        priority,
        editorValue,
        setEditorValue=()=>{},
        bucketId = FileManagerTypes.PROJECT_IMAGES.id,
        title="تصویر تکی"
    }
) {

    const [imageUrl, setImageUrl] = useState("");
    const [lastUploadedImageId, setLastUploadedImageId] = useState(-1);


    const [galleryDialogOpenState, setGalleryDialogOpenState] = useState(false);

    function handleOpenFileManager() {
        setGalleryDialogOpenState(true)
    }

    function handleSelectImage(id, url) {
        setImageUrl(url)
        setLastUploadedImageId(id)

        setValue(url)
        setImageId(id)

        changeContent(
            editorValue,
            setEditorValue,
            prepareEditorItem(url, EditorItemType.IMAGE),
            priority)
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={_ => {
                    setGalleryDialogOpenState(false)
                }}
                open={galleryDialogOpenState}
                dialogSize={DialogSize.LARGE}
                pageTitle={"تصویر مورد نظر خود را انتخاب نمایید."}
            >
                <FileManagerSelector
                    setOpenDialog={setGalleryDialogOpenState}
                    bucketId={bucketId}
                    setSelectedFileUrl={handleSelectImage}
                />

            </RaikoDefaultDialogPage>
            <div className={"baseInternalImageSelector"}>

                <div className={"internalImageItemsContainer"}>
                    <RaikoSectionContainer
                        title={title}
                        actionButtonTitle={value ? "تغییر تصویر" : "انتخاب تصویر"}
                        hasActionButton
                        actionButtonOnclick={handleOpenFileManager}
                    >
                        {
                            value ? <div className={"imageViewerContainer"}>

                                    <Fancybox
                                        options={{
                                            Carousel: {
                                                infinite: false,
                                            },
                                        }}
                                    >
                                        <a href={value} data-fancybox={"gallery"} data-caption={priority}>
                                            <img
                                                src={value}
                                                alt={priority}/>
                                        </a>

                                    </Fancybox>
                                </div> :
                                <div
                                    className={"imageNotSelectedContainer"}
                                    onClick={handleOpenFileManager}
                                >
                                    <img src={thumbnail} alt=""/>
                                    <span>برای انتخاب تصویر کلیک نمایید.</span>

                                </div>
                        }
                    </RaikoSectionContainer>

                </div>


            </div>
        </>
    )
}